<template>
    <div class="chi-square-wrapper">
        <div
            ref="subTable"
            class="tr viewport-3-chi-square"
            v-bind:class="control2.chiSquare.pIsSignificantClass"
        >
            <div class="subTable the-elements">
                <div
                    v-for="(v, i) in theValues"
                    class="the-element"
                    v-bind:key="'va' + i"
                >
                    <div align="center">{{ v.name }}</div>
                    <div align="right" :class="v.valueClass">
                        {{ v.value }}
                    </div>
                </div>
            </div>
        </div>
        <div class="hide-on-print viewport-1-chi-square">
            <div
                v-for="(v, i) in theValues"
                v-bind:key="'vb' + i"
                class="the-element"
            >
                <div>{{ v.name }}</div>
                <div v-bind:class="v.valueClass">
                    {{ v.value }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import common from '@/scripts/common';
import store from '@/store';

export default {
    props: ['control1', 'control2'],
    mounted: function () {
        const vm = this;
        vm.id = 'chiSquare_' + vm._uid;
        //We are only setting width
        store.dispatch('loadedControls/mounted', {
            name: 'chiSquare',
            control1: vm.control1,
            control2: vm.control2,
            vm,
            subTable: vm.$refs.subTable,
            id: vm.id
        });
    },
    created: function () {
        const vm = this;
        const v = vm.control2.chiSquare.valueIsNull
            ? {
                  chiSquare: '.',
                  degreesOfFreedom: '.',
                  displayPValue: '.'
              }
            : {
                  chiSquare: common.formatNumber(
                      vm.control2.chiSquare.value,
                      2
                  ),
                  degreesOfFreedom: common.formatNumber(
                      vm.control2.chiSquare.degreesOfFreedom,
                      0
                  ),
                  pValue: common.formatNumber(
                      vm.control2.chiSquare.displayPValue,
                      4
                  )
              };

        vm.theValues = [
            {
                name: 'Wald Chi-Square Value',
                value: v.chiSquare,
                valueClass: 'data-cell'
            },
            {
                name: 'Degrees of Freedom',
                value: v.degreesOfFreedom,
                valueClass: 'data-cell'
            },
            {
                name: 'p-value',
                value: v.pValue,
                valueClass:
                    'data-cell' + vm.control2.chiSquare.pIsSignificantClass
            }
        ];
    },
    data: function () {
        return {
            common: common,
            id: '',
            byColumn: [],
            byRow: []
        };
    },
    components: {},
    methods: {}
};
</script>

<style scoped>
.the-elements {
    font-size: 14px;
}

.the-element > div {
    border: 2px solid;
    padding: 3px 8px 3px 8px;
}

.viewport-3-chi-square .the-element {
    width: 180px;
    position: relative;
    float: left;
}

.viewport-1-chi-square .the-element > div:first-child {
    float: left;
    width: 70%;
}

.viewport-1-chi-square .the-element > div:nth-child(2) {
    float: left;
    width: 20%;
}
.viewport-1-chi-square .the-element {
    width: 100%;
    overflow: auto;
    /* width: fit-content; */
}

.the-element {
    padding: 0 0 0 0;
    /*max-width: 180px;*/
    display: block;
}

.chi-square-wrapper {
    overflow-x: hidden;
}
/*.th, .td {
    white-space: nowrap;
  }*/

@media screen {
    .row div.the-element:first-child {
        margin-left: 15px;
    }
    .the-elements {
        width: 560px;
    }
}

@media print {
    .row .the-element:first-child {
        margin-left: 30px;
    }

    .the-element div {
        /*width: 250px;*/
        /*display: inline-block;*/
        /*font: 12pt Georgia,"Times New Roman",Times,serif!important;*/
    }

    .the-element {
        /*width:250px;*/
        /*display: inline-block;*/
        width: 200px;
        max-width: none;
        display: block;
        float: left;
        position: relative;
    }
    .the-elements {
        width: 640px;
    }
}

.viewport-3-chi-square {
    width: fit-content;
}

@media (max-width: 767px) {
    .viewport-3-chi-square {
        display: none;
    }
}

@media (min-width: 768px) {
    .viewport-1-chi-square {
        display: none;
    }
}

.data-cell {
    min-height: 25.2px;
}
@media (max-width: 480px) {
    .data-cell {
        padding-left: 20px !important;
    }
    .the-element > div {
        box-sizing: border-box;
        width: 80% !important;
    }
}
</style>
